import React, { useState, useEffect, useRef } from "react";
import { TranslationHint } from "../../helper/TranslationHint";
import { Modal, Form, Input, Button, Select } from "antd";
import { callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import { makeMapLinkEditValidator, MAP_LINK_HINT } from "../../helper/mapLink";
import { Buffer } from "buffer";
import { PLACEHOLDER_IMAGE } from "../../helper/placeholderImage";
const AWS = require("aws-sdk");

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
});

const AddCategory = ({
  visible,
  item,
  toggleModal,
  recordData,
  addProduct,
  setAddProduct,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [roots, setRoots] = useState([]);
  const [stages, setStages] = useState([]);
  const [fileError, setFileError] = useState("");
  const fileInputRef = useRef(null);
  const { Option } = Select;

  // Title/description are stored as { en, es, ... } translation objects on the backend.
  // A plain <Input> can only display a string, so pick one language to show/edit.
  const displayText = (val) =>
    typeof val === "string"
      ? val
      : val?.en || val?.es || Object.values(val || {})[0] || "";

  useEffect(() => {
    if (visible && recordData) {
      console.log("record data", recordData);
      form.setFieldsValue({
        title: displayText(recordData?.title),
        description: displayText(recordData?.description),
        type: recordData?.type,
        eventDateTime: recordData?.eventDateTime,
        image: recordData.image,
        location: recordData.location.address,
        route: recordData.route._id,
        stage: recordData.stage._id,
      });
      setImage(recordData.image || PLACEHOLDER_IMAGE);
    }
  }, [visible, recordData, form]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        `${routes.getAllRoots}`,
        null,
        setIsLoading,
        (res) => {
          console.log("All Roots data ", res);
          if (res.status === 200) {
            setRoots(res.data.routes);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        `${routes.getStages}`,
        null,
        setIsLoading,
        (res) => {
          console.log("All stages data ", res);
          if (res.status === 200) {
            console.log("okkk");
            setStages(res.data.stages);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  const pickImageFile = () => {
    fileInputRef.current.click();
  };

  const S3 = new AWS.S3();
  const uploadImageOnS3 = async (src) => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onload = async () => {
          const params = {
            Bucket: "goodeway",
            Key: `${10000 + Math.round(Math.random() * 10000)}.png`,
            Body: Buffer.from(
              reader.result.replace(/^data:image\/\w+;base64,/, ""),
              "base64"
            ),
          };
          let res = await S3.upload(params).promise();
          console.log(res);
          return resolve(res.Location);
        };
        reader.onerror = (e) => console.log("OOPS!", e);
        reader.readAsDataURL(src);
      } catch (error) {
        console.error("Error uploading to S3:", error);
        reject(error);
      }
    });
  };

  const handleFileChange = (event) => {
    const fileList = event.target.files;

    if (fileList.length > 0) {
      const file = fileList[0];

      const reader = new FileReader();
      reader.onloadend = async () => {
        const thumbnailUrl = await uploadImageOnS3(file);
        console.log("urls3 ", thumbnailUrl);
        setImage(thumbnailUrl);
        setFileError("");
      };
      reader.readAsDataURL(file);
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSave = () => {
    setIsLoading(true);
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          ...values,
          image: image,
        };
        console.log("Body", requestBody);
        console.log("requestBody", requestBody);
        callApi(
          "PATCH",
          `${routes.updateBusiness}/${recordData._id}`,
          requestBody,
          setIsLoading,
          (res) => {
            if (res.status === 200) {
              GreenNotify("Point Of Interest Updated Successfully");
              toggleModal();
            } else {
              console.log("else :::", res);
              RedNotify("Error Occurred. Please try again later.");
            }
          },
          (error) => {
            console.error("API Call Error:", error);
            RedNotify(
              "An error occurred during the API call. Please try again later.",
              error
            );
          }
        );
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        console.error("Validation Error:", errorInfo);
      });
  };

  return (
    <Modal
      title={"Update Business"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isLoading}
          disabled={isLoading}
        >
          Update
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Title"
          extra={<TranslationHint />}
          name="title"
          rules={[
            {
              required: true,
              message: "Please enter the title",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          extra={<TranslationHint />}
          name="description"
          rules={[{ required: true, message: "Please enter the description" }]}
        >
          <Input.TextArea autoSize={{ minRows: 2, maxRows: 6 }} />
        </Form.Item>
        <Form.Item
          label="Location"
          name="location"
          rules={[
            { required: true, message: "Please enter the location" },
            // The form pre-fills this with the saved address, so leaving it untouched
            // must pass - it simply means "don't change the location".
            { validator: makeMapLinkEditValidator(recordData?.location?.address) },
          ]}
          extra={MAP_LINK_HINT}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Route"
          name="route"
          rules={[{ required: true, message: "Please select a Route" }]}
        >
          <Select placeholder="Select a Route">
            {roots.map((root) => (
              <Option key={root._id} value={root._id}>
                {root.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Stage"
          name="stage"
          rules={[{ required: true, message: "Please select stage" }]}
        >
          <Select placeholder="Select a stage">
            {stages.map((stage) => (
              <Option key={stage._id} value={stage._id}>
                {stage.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: "Please select the type" }]}
        >
          <Select placeholder="Select Type">
            <Option value="Event">Event</Option>
            <Option value="LocalShop">LocalShop</Option>
            <Option value="Restaurant">Restaurant</Option>
            <Option value="LandMark">LandMark</Option>
            <Option value="Church">Church</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Date & Time (epoch milliseconds)"
          name="eventDateTime"
        >
          {/* Shown for every type, matching the create form - any record can now carry a
              date, and one saved without it simply has no date line in the app.

              This stays a plain Input rather than the create form's DatePicker, so it
              shows the stored value as epoch milliseconds. Changing it needs the value
              converted both ways, and antd 5 pickers use dayjs while this project has
              moment - a swap worth doing deliberately, not as a side effect of this fix. */}
          <Input />
        </Form.Item>

        <div
          onClick={pickImageFile}
          style={{ marginBottom: "2rem" }}
          className="add-product-modal-input-title"
        >
          <h2> Image</h2>
          <div className="add-product-modal-image">
            <img src={image ? image : PLACEHOLDER_IMAGE} alt="" />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            required
          />
          {fileError && <p style={{ color: "red" }}>{fileError}</p>}
        </div>
      </Form>
    </Modal>
  );
};

export default AddCategory;
